module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/highlight.093b4540.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/highlight.png
// module id = 2750
// module chunks = 11